import React from "react";
import { inject, observer } from "mobx-react";

@inject("userStore")
@observer
export class FooterHomepage extends React.Component {
  render() {
    const {
      get_obj_userData,
    } = this.props.userStore
    
    const styles = {
      FooterBar: {
        display: 'flex',
        flexDirection: 'column',
        height: "50px",
        position: "fixed",
        width: "100%",
        bottom: 0,
        backgroundColor: "#003299",
        borderTop: "3px solid #003299",
      },
      FooterBarText: {
        marginRight: "15px",
        textAlign: "end",
        color: "white",
        fontWeight: "bold",
      },
      FooterBarVersion: {
        marginRight: "15px",
        textAlign: "end",
        color: "grey",
        fontWeight: "bold",
      }
    };
    return (
      <>
        <div style={styles.FooterBar}>
          <div style={styles.FooterBarText}>BIRD@ecb.europa.eu</div>
          <div style={styles.FooterBarVersion}>{get_obj_userData?.version}-{get_obj_userData?.build}</div>
        </div>
      </>
    );
  }
}
